import { ISagaCb } from '@typings/requestPayloads'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { STATUS } from '@features/General'

export interface IMeetingRequestInfoByTokenPayload extends ISagaCb {
    token: string
}

export interface IOneMeetingState {
    status: string
    data: any
    errors: any
}

const initialState: IOneMeetingState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const meetingRequestInfoByToken = createSlice({
    name: 'meeting-requests/info-by-token',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IMeetingRequestInfoByTokenPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const meetingRequestInfoByTokenActions = meetingRequestInfoByToken.actions
export default meetingRequestInfoByToken.reducer
